import * as React from "react";
import useProductName from "brand-customization/useProductName";
const TeamNameAttribute = () => {
  const productName = useProductName();
  return /* @__PURE__ */ React.createElement("span", null, "Which Active Directory attribute to use for the full name of the team in ", productName, ", e.g.", " ", /* @__PURE__ */ React.createElement("code", { key: "team-name-attribute-example" }, "cn"), ".");
};
const GroupSearchPattern = () => {
  const productName = useProductName();
  return /* @__PURE__ */ React.createElement("span", null, "The search pattern used to find groups in Active Directory for mapping to ", productName, " teams, e.g.", " ", /* @__PURE__ */ React.createElement("code", { key: "group-search-pattern" }, "(objectClass=group)"), ".");
};
const help = {
  groupSearchBase: /* @__PURE__ */ React.createElement("span", null, "The base tree to limit the Active Directory group search query to, e.g.", " ", /* @__PURE__ */ React.createElement("code", { key: "group-search-base-example" }, "ou=people,dc=example,dc=com"), "."),
  groupSearchPattern: /* @__PURE__ */ React.createElement(GroupSearchPattern, null),
  teamNameAttribute: /* @__PURE__ */ React.createElement(TeamNameAttribute, null),
  teamDefaultRoles: "The default roles synchronized teams will obtain. All users of a team will inherit these roles."
};
const excludedFields = {
  teamUniqueIdAttribute: true
};
const initialValues = {
  teamNameAttribute: "cn",
  groupSearchPattern: "(objectClass=group)"
};
export default { help, excludedFields, initialValues };
